import { Stack, Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { type BeneficiaryStatusProps } from './types';
import {
  BeneficiaryServicesColors,
  BeneficiaryServicesIconName,
  BeneficiaryServicesName,
  BeneficiaryServicesStatusEnum,
} from '../../constants/status';

export function BeneficiaryStatus({
  status,
}: Readonly<BeneficiaryStatusProps>) {
  const statusKey = status as BeneficiaryServicesStatusEnum;
  return (
    <Stack gap={0.25} flexDirection="row" alignItems="center">
      <Icon
        size={16}
        color={BeneficiaryServicesColors[statusKey]}
        name={BeneficiaryServicesIconName[statusKey]}
      />
      <Typography
        variant="text"
        fontWeight={600}
        color={BeneficiaryServicesColors[statusKey]}
      >
        {BeneficiaryServicesName[statusKey]}
      </Typography>
    </Stack>
  );
}
